import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './style/global.css'
import './style/app.css'
import './assets/iconfont/iconfont.css'
import './assets/font/font.css'
import 'animate.css';
import utils from './utils/index'
import axios from 'axios';
import md5 from 'js-md5';
import store from "./store/index.js"
import api from './api/index.js'

Vue.prototype.$api = api
Vue.prototype.$store = store
Vue.prototype.$axios = axios;

Vue.config.productionTip = false
Vue.prototype.$utils = utils
Vue.prototype.$md5 = md5;
Vue.use(ElementUI)
const baseSize = 16
function setRem () {
    const scale = document.documentElement.clientWidth / 1920
    document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px'
}
setRem()
window.onresize = function () {
  setRem()
}

Vue.directive('animate-on-scroll', {
  inserted(el, binding) {
    const { 
      animation = 'animate__fadeInUp', 
      threshold = 0.1 
    } = binding.value || {};
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            el.classList.add('animate__animated', animation);
            observer.unobserve(el)
          }
        })
      },
      { threshold }
    )
    observer.observe(el);
    el._observer = observer
  },
  unbind(el) {
    if (el._observer) {
      el._observer.disconnect();
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
